export const RESIDENT_PAYMENTS = {
  PAYMENT_METHOD: 'Payment Methods',
  RECENT_PAYMENTS: 'Receipts',
  'section.transaction.no_history': 'No payments yet',
  subtext:
    'Based on your current lease, rent will be automatically deducted on the <span><b>1st of each month.</b></span> You may add a backup method as well to ensure <span>on-time payment.</span>',
};
